// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.ButtonBar {
    position: relative;
    display: flex;
    margin: 0.25em 0;
}

div.ButtonBar.buttonbar-disabled:before {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    content: '';
}

div.ButtonBar.buttonbar-disabled div.buttonbar-button-container > button {
    background-color: var(--button-bg-color-disabled);
    color: var(--button-text-color-disabled);
}

div.ButtonBar div.buttonbar-button-container {
    position: relative;
    flex: 1 1 auto;
}

div.ButtonBar div.buttonbar-button-container > button {
    width: 100%;
}

span.buttonbar-button-tooltip {
    position: absolute;
    display: none;
    background-color: var(--tooltip-bg-color);
    border: 1px solid var(--tooltip-border-color);
    color: var(--tooltip-text-color);
    font-size: 75%;
    font-weight: normal;
    padding: 0.5em;
    border-radius: 0.5em;
    white-space: nowrap;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
}

span.buttonbar-button-tooltip-top {
    bottom: 110%;
}

span.buttonbar-button-tooltip-bottom {
    top: 110%;
}

div.ButtonBar div.menubutton {
    height: 2em;
    flex: 1 1 auto;
}

div.buttonbar-button-container:hover span.buttonbar-button-tooltip,
div.ButtonBar div.menubutton-button:hover span.buttonbar-button-tooltip {
    display: inline;
}

div.buttonbar-combo-entry {
    display: flex;
    align-items: center;
}

div.buttonbar-combo-entry > span.icon {
    flex: 0 0 auto;
}

div.buttonbar-combo-entry > span.buttonbar-combo-entry-label {
    flex: 1 1 auto;
}

div.buttonbar-combo-entry {
    display: flex;
    align-items: center;
}

div.buttonbar-combo-entry > span.buttonbar-combo-entry-label {
    margin: 0 0.5em;
}`, "",{"version":3,"sources":["webpack://./components/widgets/style/ButtonBar.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;AACf;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yCAAyC;IACzC,6CAA6C;IAC7C,gCAAgC;IAChC,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB","sourcesContent":["div.ButtonBar {\n    position: relative;\n    display: flex;\n    margin: 0.25em 0;\n}\n\ndiv.ButtonBar.buttonbar-disabled:before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: '';\n}\n\ndiv.ButtonBar.buttonbar-disabled div.buttonbar-button-container > button {\n    background-color: var(--button-bg-color-disabled);\n    color: var(--button-text-color-disabled);\n}\n\ndiv.ButtonBar div.buttonbar-button-container {\n    position: relative;\n    flex: 1 1 auto;\n}\n\ndiv.ButtonBar div.buttonbar-button-container > button {\n    width: 100%;\n}\n\nspan.buttonbar-button-tooltip {\n    position: absolute;\n    display: none;\n    background-color: var(--tooltip-bg-color);\n    border: 1px solid var(--tooltip-border-color);\n    color: var(--tooltip-text-color);\n    font-size: 75%;\n    font-weight: normal;\n    padding: 0.5em;\n    border-radius: 0.5em;\n    white-space: nowrap;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 2;\n}\n\nspan.buttonbar-button-tooltip-top {\n    bottom: 110%;\n}\n\nspan.buttonbar-button-tooltip-bottom {\n    top: 110%;\n}\n\ndiv.ButtonBar div.menubutton {\n    height: 2em;\n    flex: 1 1 auto;\n}\n\ndiv.buttonbar-button-container:hover span.buttonbar-button-tooltip,\ndiv.ButtonBar div.menubutton-button:hover span.buttonbar-button-tooltip {\n    display: inline;\n}\n\ndiv.buttonbar-combo-entry {\n    display: flex;\n    align-items: center;\n}\n\ndiv.buttonbar-combo-entry > span.icon {\n    flex: 0 0 auto;\n}\n\ndiv.buttonbar-combo-entry > span.buttonbar-combo-entry-label {\n    flex: 1 1 auto;\n}\n\ndiv.buttonbar-combo-entry {\n    display: flex;\n    align-items: center;\n}\n\ndiv.buttonbar-combo-entry > span.buttonbar-combo-entry-label {\n    margin: 0 0.5em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
